import {Sprite, Text, Texture} from 'pixi.js';
import {TextFactory} from '../../factories/TextFactory';
import {Pivot} from '../../utils/Pivot';
import {TextureUrlLoader} from '../../utils/TextureUrlLoader';
import {OutlineFilter} from '@pixi/filter-outline';

export class Tooltip extends Sprite
{
    private textField: Text;
    private lockIcon: Sprite | undefined;
    private outlineFilter: OutlineFilter = new OutlineFilter(1, 0x0);

    constructor() {
        super();

        this.textField = TextFactory.create('', 16);
        this.textField.style.stroke = 0;
        this.textField.style.strokeThickness = 2;
        this.addChild(this.textField).y = -13;
        this.interactive = this.interactiveChildren = false;
        Pivot.centerPivot(this.textField);

        this.loadLockIcon();
    }

    /**
     * Загрузка иконки замочка
     */
    async loadLockIcon() {
        const iconPath = '/images/context-menu/ic_lock.svg';
        let iconTexture: Texture | null = await TextureUrlLoader.load(iconPath);
        this.lockIcon = new Sprite(iconTexture!);
        this.lockIcon.anchor.set(.5, .5);
        this.lockIcon.y = -35;
        this.lockIcon.filters = [this.outlineFilter];
        this.addChild(this.lockIcon).visible = false;
    }

    /**
     * Установка текста тултипа
     * @param text - устанавливаемый текст (кол-во карт)
     */
    setText(text: string) {
        this.textField.text = text;
        Pivot.centerPivot(this.textField);
    }

    /**
     * Установка видимости иконки лока
     * @param locked - видима ли иконка лока
     */
    setLock(locked: boolean) {
        this.lockIcon!.visible = locked;
    }
}
